import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { getSimUnitData } from "@/services/project/simulation.service"
import { useRequest } from "ahooks"
import { useContext, useMemo } from "react"
import { isArray} from 'lodash-es'
import { numberFixTo } from "../utils"
import { Select } from "antd"
import { getProjectPropertySets } from "@/store/project/selector"
import { useSelector } from "react-redux"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"

interface CompositionSelectProps {
  unitId: string
  className?: string 
  value?: number
  onChange?: (index: number) => void
}

export const CompositionSelect = (props: CompositionSelectProps) => {
  const {unitId, className, onChange, value} = props;
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const propertySets = useSelector(getProjectPropertySets)
  const {data, run} = useRequest(() => getSimUnitData({sId: flowSimulation?.id, id: unitId}))
  const outData = data?.vars?.OUT || {} as any
  const compositions = outData?.xi_$1 ?? []
  const setName = data?.args?.tpps
  const compositionValue: number[] = isArray(compositions) ? compositions as number[] : (compositions?.val || [])

  const options = useMemo(() => {
    if (!(setName && propertySets && compositionValue)) {
      return []
    }
    const propertySet = propertySets.find(item => item.name === setName)
    if (!propertySet) {
      return []
    }
    const dataList = propertySet.components.map((item, index) => {
      const fraction = numberFixTo(compositionValue[index], 6) || 0;
      return {
        label: `${item.name}: ${fraction}`,
        value: index,
        fraction
      }
    })
    return dataList
  }, [propertySets, setName, compositionValue])

  return <Select options={options} style={{width: '100%'}} className={className} value={value} onChange={onChange} />
}